import type { ComponentData, Options } from './types.tsx';

export const mapDataToOptions = (data: ComponentData): Options =>
	data.map(({ id, name }) => ({ label: name, value: id }));

export const mapOptionsToData = (data: Options): ComponentData =>
	data.map(({ label, value }) => ({ id: value, name: label }));
